<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
}
</script>

<template>
  <div :class="$style.wrapper">
    <div :class="$style['inner__left']">
      <h2>
        <slot name="title">{{ title }}</slot>
      </h2>
      <p v-if="$slots.subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </p>
    </div>
    <div v-if="$slots.center" :class="$style['inner__center']">
      <slot name="center"></slot>
    </div>
    <div :class="$style['inner__right']">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5em;
}
.inner {
  &__right {
    text-align: right;
  }
  &__center {
    width: 60%;
  }
}
</style>
